import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const NotAvailableText = styled.p`
  letter-spacing: 0.3px;
  line-height: 36px;
  color: #212529;
  margin: 50px auto;
  font-size: 25px;
  padding: 40px;
  background-color: #efefef;
  text-align: center;
`;
